import { createContext, useContext } from 'react'

const MainContainerMinMarginsContext = createContext({
	top: 0,
	bottom: 0,
})

export const MainContainerMinMarginsContextProvider = MainContainerMinMarginsContext.Provider

/**
 * @return {Object.<string, PageMetaData>}
 */
export const useMainContainerMinMargins = () => {
	const context = useContext(MainContainerMinMarginsContext)
	if (context === undefined) {
		throw new Error('useMainContainerMinMargins must be used within a MainContainerMinMarginsContextProvider')
	}
	return context
}
